export default{
    ustawScrollNaSidebarze(){
        let modules = document.getElementsByClassName('moduleLink')

        for(let i = 0;i<modules.length;i++){
            if(window.location.href.indexOf(modules[i].getAttribute('id'))>-1){
                modules[i].scrollIntoView()

            }
        }
    },

    renderFileIcon(typ) {

        if (typ.indexOf('doc') > -1) {
            return 'fa fa-file-word-o'
        }
        else if (typ.indexOf('pdf') > -1) {
            return 'fa fa-file-pdf-o'
        }
        else if (typ.indexOf('xls') > -1) {
            return 'fa fa-file-excel-o'
        }
        else if (typ.indexOf('text/plain') > -1) {
            return 'fa fa-file-text-o'
        }
        else if (typ.indexOf('htm') > -1 || typ.indexOf('js') > -1) {
            return 'fa fa-file-code-o'
        }
        else if (typ.indexOf('zip') > -1 || typ.indexOf('rar') > -1) {
            return 'fa fa-file-archive-o'
        }
        else if(typ.indexOf('image')>-1){
            return 'fa fa-image'
        }

        return 'fa fa-file-o'
    },


}


// WEBPACK FOOTER //
// ./src/utilities/othersUtilities/OthersUtilities.js